module.exports = __webpack_public_path__ + "img/qred.5363950.png";